import React from "react";
import styled from "styled-components";
import { useTheme } from "styled-components";
import { Button, Text } from "../UI";
import { repairPagesStore } from "../stores";

export const getStatusColor = (message, theme) => {
  const statuses = repairPagesStore.statuses;
  return statuses?.find((obj) => obj.STATDES === message.STATDES)?.VCOLORRGB;
};
export const hasWhiteLabel = (message, theme) => {
  const statuses = repairPagesStore.statuses;
  return (
    statuses?.find((obj) => obj.STATDES === message.STATDES)?.WHITE_LABEL ===
    "Y"
  );
};

export const StatusLabel = styled("div")(
  ({ theme, backgroundColor, width, height, color, borderColor }) => ({
    height: height ? height : "auto",
    width: width ? width : "auto",
    minWidth: "max-content",
    backgroundColor: backgroundColor || theme.color.white,
    borderRadius: 70,
    fontWeight: "bold",
    fontSize: 14,
    color: color || theme.color.black,
    textAlign: "center",
    verticalAlign: "middle",
    lineHeight: "22px",
    padding: "0px 12px",
    border: borderColor ? `1px solid ${borderColor}` : "none",
  })
);

export const CircleDiv = styled("div")(
  ({ theme, backgroundColor, width, height, withMargin }) => ({
    minHeight: height ? height : 50,
    minWidth: width ? width : 50,
    backgroundColor: backgroundColor || theme.color.white,
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    display: "flex",
    marginInlineStart: 0,
    borderRadius: "50%",
    alignSelf: "center",
  })
);

export const ScrollDiv = styled("div")(
  ({ theme, maxHeight, minHeight, scrollX, isMobile }) => ({
    overflowY: "auto",
    overflowX: !!scrollX ? "auto" : "hidden",
    maxHeight: maxHeight || "50vh",
    minHeight: minHeight || "unset",
    width: "100%",

    "&::-webkit-scrollbar": {
      backgroundColor: theme.color.gray30,
      width: isMobile ? 4 : 8,
      height: 8,
    },
    "&::-webkit-scrollbar-thumb": {
      height: "1%",
      width: 8,
      backgroundColor: theme.color.gray70,
    },
  })
);

export const Box = styled("div")(
  ({ theme, backgroundColor, isMobile, width }) => ({
    backgroundColor: backgroundColor || theme.color.white,
    display: "flex",
    flexDirection: "column",
    borderRadius: isMobile ? 0 : 30,
    boxShadow: isMobile
      ? `0px 4px 15px 0px rgba(181, 164, 250, 0.30)`
      : `0px 4px 15px 0px #B5A4FA4D`,
    padding: isMobile ? 0 : 0,
    paddingBottom: 0,
    width: width ? width : 460,
    border: `1px solid ${theme.color.gray50}`,
  })
);

export const MobileBox = styled("div")(({ theme }) => ({
  backgroundColor: theme.color.white,
  display: "flex",
  flexDirection: "column",
  borderRadius: 24,
  boxShadow: `0px 4px 15px 0px rgba(181, 164, 250, 0.30)`,
}));

export const InnerBox = styled("div")(
  ({ theme, color, backgroundColor, flexBasis, isMobile, noPadding }) => ({
    backgroundColor: backgroundColor || theme.color.white,
    color: color || theme.color.gray90,
    borderRadius: "18px",
    display: "flex",
    flex: 1,
    flexBasis: flexBasis ? `${flexBasis}%` : `100%`,
    flexDirection: "column",
    alignItems: "flex-start",
    marginBottom: isMobile ? 0 : 0,
    padding: noPadding ? 0 : isMobile ? 20 : "30px 40px",
  })
);
export const SmallBox = styled("div")(
  ({ theme, color, backgroundColor, flexBasis, isMobile, noPadding }) => ({
    backgroundColor: backgroundColor || theme.color.white,
    color: color || theme.color.gray90,
    borderRadius: "18px",
    display: "flex",
    flex: 1,
    flexBasis: flexBasis ? `${flexBasis}%` : `100%`,
    flexDirection: "column",
    alignItems: "flex-start",
    marginBottom: isMobile ? 0 : 0,
    padding: noPadding ? 0 : 20,
    boxShadow: "0px 4px 15px 0px #B5A4FA4D",
    border: `1px solid ${theme.color.gray50}`,
  })
);

export const Item = styled("div")(
  ({ theme, color, backgroundColor, flexBasis }) => ({
    backgroundColor: backgroundColor || theme.color.white,
    color: color || theme.color.gray90,
    display: "flex",
    flex: 1,
    flexBasis: flexBasis ? `${flexBasis}%` : `100%`,
    flexDirection: "column",
    alignItems: "flex-start",
  })
);

export const BoxHeader = styled("div")(
  ({ theme, color, backgroundColor, flexBasis, borderColor }) => ({
    backgroundColor: backgroundColor || theme.color.white,
    color: color || theme.color.gray90,
    borderRadius: "18px 10px 0 0",
    display: "flex",
    flex: 1,
    flexBasis: flexBasis ? `${flexBasis}%` : `100%`,
    flexDirection: "column",
    alignItems: "flex-start",
    borderBottom: "1px solid",
    padding: 20,
    borderColor: borderColor || theme.color.gray30,
  })
);

export const TextSpeech = styled("div")(
  ({
    theme,
    color,
    backgroundColor,
    positionFromTop,
    height,
    width,
    borderRadius,
    boxShadow = false,
    position,
  }) => ({
    backgroundColor: backgroundColor || theme.color.gray10,
    color: color || theme.color.gray90,
    position: position || "relative",
    padding: 10,
    margin: "10px 20px",
    height: height || "unset",
    width: width || "unset",
    minHeight: 70,
    borderRadius: borderRadius || 0,
    boxShadow: boxShadow ? `0px 4px 28px 0px #00000040` : "unset",

    "&:before": {
      content: '" "',
      position: "absolute",
      right: positionFromTop ? 0 : "-20px",
      left: "auto",
      bottom: "auto",
      top: positionFromTop || "0px",
      width: 0,
      height: 0,
      marginTop: positionFromTop ? "-20px" : 0,
      marginRight: positionFromTop ? "-9px" : "0",
      border: positionFromTop ? "10px solid transparent" : "22px solid",
      borderRightWidth: positionFromTop ? "0px" : "22px",
      borderColor: positionFromTop
        ? `transparent transparent transparent ${
            backgroundColor || theme.color.gray10
          }`
        : `${
            backgroundColor || theme.color.gray10
          } transparent transparent transparent`,
    },
  })
);

export const List = styled("ul")(({ flexDirection, gap }) => ({
  margin: 0,
  padding: 0,
  display: "flex",
  gap: gap || 20,
  flexDirection: flexDirection || "row",
  flexWrap: "wrap",
}));

export const ListItem = styled("li")(
  ({ width, height, listStyleType, backgroundImage, theme }) => ({
    width: width || 60,
    height: height || 70,
    listStyleType: listStyleType || "none",
    backgroundImage: `url(${backgroundImage})` || "unset",
    display: "inline-block",
    margin: 5,
    backgroundSize: "cover",
    borderRadius: 4,

    ":hover": {
      borderRadius: 20,
      backgroundColor: theme.color.gray10,
    },
  })
);

export const SaveSuccess = ({ buttonLabel, textLabel, onButtonClick }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        borderRadius: 18,
        gap: 50,
        margin: 50,
      }}
    >
      <Text.H3>{textLabel}</Text.H3>
      <Button onClick={onButtonClick}>{buttonLabel}</Button>
    </div>
  );
};

// Styled button component for delivery method buttons
const DeliveryMethodButtonStyled = styled("div")(
  ({ theme, iconColor, disabled }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "10px 14px",
    backgroundColor: theme.color.white,
    border: `1px solid ${theme.color.gray50}`,
    borderRadius: "70px",
    cursor: disabled ? "not-allowed" : "pointer",
    marginTop: "10px",
    alignSelf: "center",
    width: "100%",
    maxWidth: "400px",
    transition: "all 0.2s ease",
    opacity: disabled ? 0.6 : 1,
    pointerEvents: disabled ? "none" : "auto",
    "&:hover": {
      backgroundColor: disabled ? theme.color.white : theme.color.gray10,
    },
    "&:active": {
      backgroundColor: disabled ? theme.color.white : theme.color.gray30,
    },
  })
);

export const DeliveryMethodButton = React.forwardRef(({
  onClick,
  icon,
  text,
  iconColor,
  disabled = false,
}, ref) => {
  const theme = useTheme();
  return (
    <DeliveryMethodButtonStyled
      ref={ref}
      onClick={disabled ? undefined : onClick}
      theme={theme}
      iconColor={iconColor}
      disabled={disabled}
    >
      {icon && (
        <div
          style={{
            color: iconColor || theme.color.gray90,
            display: "flex",
            alignItems: "center",
          }}
        >
          {icon}
        </div>
      )}
      <Text.BR
        color={theme.color.gray90}
        style={{
          fontSize: 14,
          cursor: disabled ? "not-allowed" : "pointer",
        }}
      >
        {text}
      </Text.BR>
    </DeliveryMethodButtonStyled>
  );
});
